import { render, staticRenderFns } from "./FinancialMerchantChannelTypeStatistics.vue?vue&type=template&id=218f76f6&"
import script from "./FinancialMerchantChannelTypeStatistics.vue?vue&type=script&lang=ts&"
export * from "./FinancialMerchantChannelTypeStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FinancialMerchantChannelTypeStatistics.vue"
export default component.exports